var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTreeFileIcon = function SvgTreeFileIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 1.00159V1H9.9989C10.2757 1 10.5 1.22766 10.5 1.4959V10.5041C10.5 10.778 10.2775 11 10.0033 11H1.9967C1.72238 11 1.5 10.7751 1.5 10.4966V4L4.5 1.00159ZM2.91459 4H4.5V2.41543L2.91459 4ZM5.5 2V4.5C5.5 4.77614 5.27615 5 5 5H2.5V10H9.5V2H5.5Z",
    fill: "#2F2F2F"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTreeFileIcon, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuNSAxLjAwMTU5VjFIOS45OTg5QzEwLjI3NTcgMSAxMC41IDEuMjI3NjYgMTAuNSAxLjQ5NTlWMTAuNTA0MUMxMC41IDEwLjc3OCAxMC4yNzc1IDExIDEwLjAwMzMgMTFIMS45OTY3QzEuNzIyMzggMTEgMS41IDEwLjc3NTEgMS41IDEwLjQ5NjZWNEw0LjUgMS4wMDE1OVpNMi45MTQ1OSA0SDQuNVYyLjQxNTQzTDIuOTE0NTkgNFpNNS41IDJWNC41QzUuNSA0Ljc3NjE0IDUuMjc2MTUgNSA1IDVIMi41VjEwSDkuNVYySDUuNVoiIGZpbGw9IiMyRjJGMkYiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };